import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { defaultColumn, DELETE_RECORD_LABEL, grid_widths_map } from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { customEncode, customEncrypt, encrypt } from '@piqet-angular/data';
@Injectable({
  providedIn: 'root',
})
export class ProductListDataGridService {
  productListDataPayload: any;
  event: any;

  deleteProduct = new Subject<[any]>();
  deleteProductData$ = this.deleteProduct.asObservable();

  copyProduct = new Subject<[any]>();
  copyProductData$ = this.copyProduct.asObservable();
  constructor(
    private readonly router: Router,
    private readonly swalService: SwalService,
    private readonly sharedService: SharedService
  ) {}

  productDataColumn(headerName?: any, hasMultipleScenarios?: boolean): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'ProductId',
      headerName: 'ProductId',
      field: 'ProductId',
      hide: true,
      suppressColumnsToolPanel: true,
    });
    colDef.push({
      ...defaultColumn,
      colId: '',
      headerName: '',
      field: '',
      rowDrag: hasMultipleScenarios,
      cellClass: 'scenarioDragIcon',
      minWidth: grid_widths_map.icon_md,
      maxWidth: grid_widths_map.icon_md,
      resizable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'ProductImage',
      headerName: '',
      field: 'productImage',
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xxm,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Product name',
      field: 'productName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      sortable: true,
      cellRenderer: 'linkRenderer',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ProductCode',
      headerName: 'Product code',
      field: 'productCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Owner',
      headerName: 'Owner',
      field: 'owner',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showView: true,
        showCopy: true,
        showDelete: true,

        deleteData: (data: any) => {
          this.deleteConfirmation(data);
        },
        copyData: (data: any) => {
          this.copyProduct.next(data);
        },
        copyDataEditRendarar: (data: any) => {
          return false;
        },
        viewData: (data: any) => {
          this.sharedService.scenarioNameFunc(data?.productName);
          localStorage.setItem('scenarioName', data?.productName);
          const encryptedValue = customEncrypt(data.productId);
          const productConfigId: any = localStorage.getItem('productConfigId');
          this.router.navigate(
            [
              `projects/product-configuration/${customEncode(
                btoa(productConfigId)
              )}/configurations`,
            ],
            {
              queryParams: {
                param: encryptedValue,
              },
            }
          );
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteProduct.next([data]);
      } else {
        console.log('Cancelled');
      }
    });
  }
}
